// sipUtils.js

export function calculateMonthlySIP(targetAmount, annualReturn, timelineYears) {
  const months = timelineYears * 12; // Convert years to months
  const monthlyRate = annualReturn / 12 / 100; // Convert annual return to monthly

  const factor = Math.pow(1 + monthlyRate, months) - 1;

  // Avoid division by zero error
  if (factor <= 0) return targetAmount / months;

  const monthlySIP = (targetAmount * monthlyRate) / factor;

  return monthlySIP;
}
